'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useEffect } from 'react';
import { GTM_ID, pageview } from '@fm-nx/tracking';
// import { GoogleTagManager } from '@next/third-parties/google';

export const GTMInit = () => {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    // https://github.com/vercel/next.js/blob/canary/examples/with-google-tag-manager/pages/_app.js
    // https://dev.to/valse/how-to-setup-google-tag-manager-in-a-next-13-app-router-website-248p
    useEffect(() => {
        if (pathname) {
            pageview(pathname);
        }
    }, [pathname, searchParams]);

    if (process.env['NODE_ENV'] !== 'production') {
        return null;
    }

    return (
        <>
            {/* <GoogleTagManager gtmId={GTM_ID} /> */}
            <noscript>
                <iframe
                    title="gtm-iframe"
                    src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
                    height="0"
                    width="0"
                    style={{ display: 'none', visibility: 'hidden' }}
                />
            </noscript>
            <Script
                id="gtm-script"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer', '${GTM_ID}');
                    `,
                }}
            />
        </>
    );
};

export default GTMInit;
